import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { PassportCircle } from '../../Icons/PassportCircle';
import { BenefitProps } from '../../interfaces/components';

const Benefit = ({ title, description, w }: BenefitProps) => {
  return (
    <Box
      w={w ? w : '300px'}
      h="max-content"
      display="flex"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      gap="4"
    >
      <Text
        textAlign="center"
        fontWeight="400"
        fontFamily="SangBleuBPLight"
        fontSize={['16px', '16px', '18px', '20px', '20px']}
        maxW="80%"
        mx="auto"
        whiteSpace="pre-line"
      >
        {title}
      </Text>
      <Text
        textAlign="center"
        fontWeight="400"
        fontFamily="JosefinSans"
        fontSize={['12px', '12px', '12px', '14px', '14px']}
        lineHeight={['16px', '16px', '16px', '18px', '18px']}
        whiteSpace="pre-line"
      >
        {description}
      </Text>
      <PassportCircle stroke="#C29F6B" boxSize="10px" />
    </Box>
  );
};

export default Benefit;
